module.exports = __webpack_public_path__ + "img/icon1.e6dbb280.png";